import INVESTMENT_TYPES from 'constants/userProfile';
import cryptoJS from 'crypto-js';

export const checkUserInvestmentTypeAndReturnActiveOne = investmentType => {
    return Object.keys(INVESTMENT_TYPES).reduce((prev, investmentTypeKey) => {
        const investmentTypeValue = INVESTMENT_TYPES[investmentTypeKey];

        if (INVESTMENT_TYPES[investmentTypeKey] === investmentType) return { ...prev, [investmentTypeValue]: true };

        return { ...prev, [investmentTypeValue]: false };
    }, {});
};

export const checkAndCreateAttrbIfExistsIn = (attrbToCompare, objectToCompare) => {
    return Object.keys(objectToCompare).reduce((prevAttrb, attrbInObject) => {
        const attrbValueInObject = objectToCompare[attrbInObject];

        if (objectToCompare[attrbInObject] === attrbToCompare) return { ...prevAttrb, [attrbValueInObject]: true };

        // else return { ...prevAttrb, [attrbValueInObject]: false, [attrbToCompare]: false };
        return { ...prevAttrb, [attrbValueInObject]: false };
    }, {});
};

export const getUserProfileData = ({ userProfile: { docNumber, recordId, userId, investmentType } }) => ({
    encryptedDocNumber: docNumber ? cryptoJS.SHA256(docNumber).toString() : '',
    recordId,
    userId,
    investmentType,
});
